// JavaScript для numbered-list
import { onReady } from '../base/init.js';

onReady(function () {
  // Код для numbered-list
});
